var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-list-title"},[_c('div',{staticClass:"r-list-title--wrapper"},_vm._l((_vm.titles),function(title,index){return _c('h3',{key:index},[_vm._v(_vm._s(title))])}),0),_c('r-hr',{attrs:{"hrStyle":"sub-primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }